import { config } from '@config'
import { ORDER_SERVICE_ENDPOINTS } from '@modules/order/constants/apiConstants'
import { HttpService } from '@services/HttpService'
import { stores } from '@stores'
import { action, observable } from 'mobx'
import { OrderType } from '@modules/common/models/enums/OrderManagement'
import { storage } from '@services/storageService'

export enum OrderTemplatePreferences {
  TEMPLATES_PREFERENCE = 'Templates'
}

class OrderTemplatePreferencesStore {
  @observable.struct templates: any = {}
  @observable isLoading = false

  private httpService = new HttpService()

  setTemplates = templates => {
    this.templates = templates
  }

  getOptions = () => {
    const accessToken: string = storage.getItem('access_token')
    return {
      Authorization: `Bearer ${accessToken}`,
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }
  }

  @action
  fetchOrderPreferences = async () => {
    const {
      nav: {
        queryParams: { orderId, orderType, clientOrderId }
      }
    } = stores
    if (!orderId) return {}
    if (orderType === OrderType.Client) {
      // Using data fetched from the same API call from table seetings API call
      // Hence avoiding duplicate API call
      return {}
    }

    const url = `${config.buyingBoardServiceRestEndpoint}${
      ORDER_SERVICE_ENDPOINTS.GET_ORDER_TABLE_SETTING
    }/${orderType === OrderType.Door ? clientOrderId : orderId}`

    return this.httpService
      .get(url, {
        headers: this.getOptions()
      })
      .then(response => {
        const data = response?.data
        this.setTemplates(data?.[OrderTemplatePreferences.TEMPLATES_PREFERENCE] || {})
        return data
      })
      .catch(e => {
        console.error('error in fetching order preferences', e)
      })
  }

  @action
  updatedOrderPreferences = async updatedPreferences => {
    const {
      nav: {
        queryParams: { orderId, orderType, clientOrderId }
      }
    } = stores

    this.templates = {
      ...updatedPreferences.Templates
    }

    const url = `${config.buyingBoardServiceRestEndpoint}${
      ORDER_SERVICE_ENDPOINTS.GET_ORDER_TABLE_SETTING
    }/${orderType === OrderType.Door ? clientOrderId : orderId}`

    return this.httpService
      .put(
        url,
        { ...updatedPreferences },
        {
          headers: this.getOptions()
        }
      )
      .then(response => {
        return response.data || {}
      })
      .catch(e => {
        console.error('error in updating order preferences', e)
      })
  }

  @action clear = () => {
    this.templates = {}
  }
}

export const orderTemplatePreferencesStore = new OrderTemplatePreferencesStore()
